module.exports = __webpack_public_path__ + "img/screen-img-02.76fc45ca.jpg";